import React from 'react';
import Dropdown, { Option } from '@app/react-common/components/dropdown/Dropdown';
import Input from '@app/react-common/components/input/Input';

export const TYPE_OPTIONS: Option[] = [
  { label: 'All Types', value: 'all' },
  { label: 'Domestic', value: 'domestic' },
  { label: 'International', value: 'international' },
];

export const STATUS_OPTIONS: Option[] = [
  { label: 'All Statuses', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

interface DeliveryMethodsFilterBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  typeFilter: Option;
  onTypeFilterChange: (option: Option) => void;
  statusFilter: Option;
  onStatusFilterChange: (option: Option) => void;
  groupByControl?: React.ReactNode;
  className?: string;
}

export const DeliveryMethodsFilterBar = ({
  searchQuery,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  statusFilter,
  onStatusFilterChange,
  groupByControl,
  className = 'delivery-methods-list',
}: DeliveryMethodsFilterBarProps) => {
  return (
    <div className={`${className}__filter-bar`}>
      <div className={`${className}__filter-bar__search`}>
        <Input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search"
          startIcon={<i className="icon icon-search" />}
        />
      </div>
      <div className={`${className}__filter-bar__filters`}>
        <Dropdown
          options={TYPE_OPTIONS}
          placeholder="All Types"
          preSelectedOption={typeFilter}
          onSelect={(option) => option && onTypeFilterChange(option)}
          width={140}
        />
        <Dropdown
          options={STATUS_OPTIONS}
          placeholder="All Statuses"
          preSelectedOption={statusFilter}
          onSelect={(option) => option && onStatusFilterChange(option)}
          width={140}
        />
        {groupByControl}
      </div>
    </div>
  );
};
